"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSortedRetailLocationsByDistance = void 0;
const react_1 = require("react");
const useRequiredContext_1 = require("../../../../hooks/useRequiredContext");
const context_1 = require("../handlers/CustomerLocationHandler/context");
const RetailLocationsContext_1 = require("../contexts/RetailLocationsContext");
const TSalesOrderType_1 = require("../types/TSalesOrderType");
const useSortedRetailLocationsByDistance = ({ type, locationMaxRange, operatingOnly }) => {
    const { retailLocations: contextRetailLocations } = (0, react_1.useContext)(RetailLocationsContext_1.RetailLocationsContext);
    const { customerLocation } = (0, useRequiredContext_1.useRequiredContext)(context_1.CustomerLocationContext);
    const latLng = (0, react_1.useMemo)(() => (customerLocation ? customerLocation : null), [
        customerLocation
    ]);
    return (0, react_1.useMemo)(() => {
        if (!Array.isArray(contextRetailLocations)) {
            return null;
        }
        let retailLocations = contextRetailLocations;
        if (type) {
            retailLocations = retailLocations.filter(loc => (type === TSalesOrderType_1.TSalesOrderType.Pickup && loc.canPickup) ||
                (type === TSalesOrderType_1.TSalesOrderType.Delivery && loc.canDeliver));
        }
        // if online only configuration set then we only show stores that have
        // ordering turned on
        if (operatingOnly) {
            retailLocations = retailLocations.filter(loc => loc.isOperating);
        }
        // if no latLong (e.g. no geolocation or postcode search)
        if (!latLng)
            return retailLocations;
        // have to filter first as some retail locations have lat or long set as 0
        // and getLocationsDistance will return null
        // the sort function will try and sort null - number
        // which resolves to -number, therefore putting in first position
        const sortedRetailLocationsByDistance = retailLocations
            .filter(loc => loc.getLocationsDistance(latLng))
            .sort((loc1, loc2) => loc1.getLocationsDistance(latLng) - loc2.getLocationsDistance(latLng));
        // if max range is given then filter down to within that distance
        // otherwise just return all retail locations
        return locationMaxRange
            ? sortedRetailLocationsByDistance.filter(retailLocation => retailLocation.getLocationsDistance(latLng) <= locationMaxRange)
            : sortedRetailLocationsByDistance;
    }, [latLng, contextRetailLocations, type, locationMaxRange, operatingOnly]);
};
exports.useSortedRetailLocationsByDistance = useSortedRetailLocationsByDistance;
//# sourceMappingURL=useSortedRetailLocationsByDistance.js.map